import LegalEntity from 'modules/core/store/models/LegalEntity'

import { Folder } from 'modules/documents/hooks/useGetFolders'

const SPAIN_FOLDERS_IDENTIFIERS = ['modelo_145_employee_es']

const MEXICO_FOLDERS_IDENTIFIERS = [
  'sat_country_default_mx',
  'imss_country_default_mx',
  'carta_renuncia_country_default_mx',
  'equipo_utilitario_country_default_mx',
]

const FOLDERS_SET = new Set([...SPAIN_FOLDERS_IDENTIFIERS, ...MEXICO_FOLDERS_IDENTIFIERS])

const FOLDERS_BY_LEGAL_ENTITY = Array.from(FOLDERS_SET)

export const showByLegalEntity = (identifier: string) => {
  return FOLDERS_BY_LEGAL_ENTITY.includes(identifier)
}

export const filterByLegalEntityCountry = (country: string, identifier: string) => {
  switch (country) {
    case LegalEntity.countryDefaults.es:
      return SPAIN_FOLDERS_IDENTIFIERS.includes(identifier)

    case LegalEntity.countryDefaults.mx:
      return MEXICO_FOLDERS_IDENTIFIERS.includes(identifier)

    default:
      return false
  }
}
export const countryFolderFilter = (country: string, folders: Folder[]) => {
  return folders.filter((folder) => {
    const identifier = folder.identifier

    if (!identifier) return true

    if (!showByLegalEntity(identifier)) return true

    return filterByLegalEntityCountry(country, identifier)
  })
}
